export const addButtonEventListener = () => {
    document.getElementById('table-summarize-button').addEventListener('click',() => {

        document.getElementById("table-summarize-input").select();

        document.execCommand('copy');
    })
}